import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";

var JoveTabs = function JoveTabs(props) {
  var value = props.value,
      className = props.className,
      list = props.list,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? '12px' : _props$fontSize,
      limitWith = props.limitWith,
      valueChange = props.valueChange;

  var _useState = useState(),
      currentTab = _useState[0],
      setCurrentTab = _useState[1];

  var _useState2 = useState([]),
      tabList = _useState2[0],
      setTabList = _useState2[1];

  var _useState3 = useState({}),
      tabConfig = _useState3[0],
      setTabConfig = _useState3[1];
  /**
   * effects
   */


  useEffect(function () {
    var configs = {
      fontSize: fontSize
    };

    if (limitWith) {
      configs = _objectSpread(_objectSpread({}, configs), {}, {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: limitWith,
        minHeight: 'auto'
      });
    }

    setTabConfig(configs);
  }, []);
  useEffect(function () {
    setTabList(list || []);
  }, [list]);
  useEffect(function () {
    setCurrentTab(value);
  }, [value]);
  /**
   * methods
   */

  var tabChangeAction = function tabChangeAction(e, newValue) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(newValue);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', className),
    children: /*#__PURE__*/_jsx(Tabs, {
      value: currentTab,
      onChange: tabChangeAction,
      variant: "scrollable",
      scrollButtons: "auto",
      "aria-label": "scrollable auto tabs example",
      children: tabList.map(function (item) {
        return /*#__PURE__*/_jsx(Tab, {
          label: item.label,
          sx: tabConfig
        }, item.value);
      })
    })
  });
};

export default JoveTabs;